import { Base64 } from 'js-base64';

const localStorageKey = 'vuoUserLocalCache';

const clearData = ({ userId }) => {
  try {
    const item = localStorage.getItem(localStorageKey);
    const data = item ? JSON.parse(Base64.decode(item)) : {};
    if (data[userId]) delete data[userId];
    localStorage.setItem(localStorageKey, Base64.encode(JSON.stringify(data)));
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
};

const deleteItem = ({ key, userId }) => {
  try {
    const item = localStorage.getItem(localStorageKey);
    const data = item ? JSON.parse(Base64.decode(item)) : {};
    if (data[userId] && data[userId][key]) delete data[userId][key];
    localStorage.setItem(localStorageKey, Base64.encode(JSON.stringify(data)));
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
};

const getItem = ({ key, userId }) => {
  try {
    const item = localStorage.getItem(localStorageKey);
    const data = item ? JSON.parse(Base64.decode(item)) : {};
    if (data[userId] && data[userId][key]) return data[userId][key];
    return null;
  } catch (err) {
    console.error(err);
    return null;
  }
};

const setItem = ({ key, value, userId }) => {
  try {
    const item = localStorage.getItem(localStorageKey);
    const data = item ? JSON.parse(Base64.decode(item)) : {};
    if (!data.hasOwnProperty(userId)) data[userId] = {};
    data[userId][key] = value;
    localStorage.setItem(localStorageKey, Base64.encode(JSON.stringify(data)));
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export default {
  clearData,
  deleteItem,
  getItem,
  setItem
};
